module.exports = __webpack_public_path__ + "static/media/main.138308e2.png";